import React from "react";
import { Box } from "@mui/material";
import TaxApplicationSelector from "my-tax/components/tax-application-selector";
import { OcCard } from "oc/components";

interface MyTaxCurrentApplicationsProps {
  label: string;
}

const MyTaxCurrentApplications = ({ label }: MyTaxCurrentApplicationsProps) => {
  return (
    <OcCard label={label}>
      <Box>
        <Box height="16px" />
        <TaxApplicationSelector
          label={
            "Összevont adóelőleg-nyilatkozat a családi kedvezmény és a két, a három, illetve a négy vagy több gyermeket nevelő anyák kedvezményének érvényesítéséről"
          }
          type="TaxDeclarationCombined"
        />
        <Box height="16px" />
        <TaxApplicationSelector
          label={
            "Adóelőleg-nyilatkozat a családi kedvezmény és járulékkedvezmény érvényesítéséről"
          }
          type="TaxDeclarationFamily"
        />
        <Box height="16px" />
        <TaxApplicationSelector
          label={
            "Adóelőleg-nyilatkozat az első házasok kedvezményének érvényesítéséről"
          }
          type="TaxDeclarationFirstMarriedPerson"
        />
        <Box height="16px" />
        <TaxApplicationSelector
          label={
            "Adóelőleg-nyilatkozat a két, a három, illetve a négy vagy több gyermeket nevelő anyák kedvezményének érvényesítéséről"
          }
          type="TaxDeclarationThreeChildren"
        />
        <Box height="16px" />
        <TaxApplicationSelector
          label={"Adóelőleg-nyilatkozat a személyi kedvezmény érvényesítéséről"}
          type="TaxDeclarationPersonal"
        />
        <Box height="16px" />
        <TaxApplicationSelector
          label={
            "Adóelőleg-nyilatkozat a 30 év alatti anyák kedvezményének érvényesítéséről"
          }
          type="TaxDecarationMotherUnder30"
        />
        <Box height="16px" />
        <TaxApplicationSelector
          label={
            "Nyilatkozat a 25 év alatti fiatalok kedvezményének részben vagy egészben történő érvényesítésének mellőzéséről"
          }
          type="TaxDeclarationUnder25"
        />
      </Box>
    </OcCard>
  );
};

export default MyTaxCurrentApplications;
